import { render } from "./home-top-courses.vue?vue&type=template&id=23995e0b"
import script from "./home-top-courses.vue?vue&type=script&lang=js"
export * from "./home-top-courses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__